/* eslint-disable jsx-a11y/control-has-associated-label */
import Popover from '@mui/material/Popover';
import React from 'react';
import { TwitterPicker } from 'react-color';

export default function ColorPicker({ color, setColor }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="pl-3">
      <button
        style={{
          backgroundColor: color.hex,
          width: 50,
          height: 50,
          borderStyle: 'none',
          borderRadius: 25,
        }}
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <TwitterPicker
          color={color}
          onChangeComplete={newColor => {
            setColor(newColor);
            handleClose();
          }}
          colors={[
            '#f43f5e',
            '#ec4899',
            '#d946ef',
            '#a855f7',
            '#8b5cf6',
            '#6366f1',
            '#3b82f6',
            '#0ea5e9',
            '#06b6d4',
            '#14b8a6',
            '#10b981',
            '#22c55e',
            '#84cc16',
            '#eab308',
            '#f59e0b',
            '#f97316',
            '#ef4444',
          ]}
          triangle="hide"
        />{' '}
      </Popover>
    </div>
  );
}
